import { req, get, post } from '@/plugins/axios'
import type { res } from './login'
import { useSource } from '@/store'

// 店铺采购配置
export const purchaseCfg = (): Promise<res> =>
  get('/customer/customer/shop/getShopPurchase')

// 更新采购配置
interface PUD {
  payRepurchaseType?: number
  purchasePriceAdd: number
}
export const purchaseUpt = (data: PUD): Promise<res> =>
  post('/customer/customer/shop/updateShopPurchase', data)

// 添加附加项配置
interface AL {
  additionConfigId: number
  ingredientsCount: number
  ingredientsSku: string
}
interface AA {
  address: string
  area: string
  city: string
  countryCode: string
  email: string
  logisticsId: string
  logisticsName: string
  postalCode: string
  sendName: string
  sendTel: string
}
interface ACD {
  additionList: AL[]
  additionScene?: number
  addressAddition?: AA
  categoryCodeList?: number[]
  shopAdditionId?: number
}
export const addAdtCfg = (data: ACD): Promise<res> =>
  post('/customer/additional/add', data)

// 更新附加项配置
export const updateAdtCfg = (data: ACD): Promise<res> =>
  post('/customer/additional/update', data)

// 删除附加项配置
interface DCD {
  shopAdditionId: number
}
export const deleteAdtCfg = (data: DCD): Promise<res> =>
  req('/customer/additional/delete', data)

// 附加项配置列表
export const AdtCfgList = (): Promise<res> => get('/customer/additional/list')

// 查询店铺已配置附加项的类目
export const categoryConfigured = (): Promise<res> =>
  post('/customer/additional/getCategoryConfigured')

// 获取推荐物流公司
export const RecommendedLogistics = (): Promise<res> =>
  post('/settlement/intShipConfig/getRecommendedLogistics', useSource())

// 获取国际物流配置
export const getShopLogistics = (): Promise<res> =>
  get('/customer/additional/getAddress')

// 保存国际物流配置
export const updateShopLogistics = (data: ACD): Promise<res> =>
  post('/customer/additional/updateAddress', data)

// 我的收货地址
interface ADDR {
  address: string
  addressEn: string
  area: string
  areaEn: string
  city: string
  cityEn: string
  countryCode: string
  phone: string
  postalCode: string
  receiveName: string
  receiveNameEn: string
  shopShippingAddressId?: string
  defaultAddress: number
}
export const getTakeAddr = (): Promise<res> =>
  get('/customer/customer/shop/getShippingAddressList')

// 更新收货地址
export const updateTakeAddr = (data: ADDR): Promise<res> =>
  post('/customer/customer/shop/updateShippingAddress', data)

// 添加收货地址
export const addTakeAddr = (data: ADDR): Promise<res> =>
  post('/customer/customer/shop/addShippingAddress', data)

// 删除收货地址
export const delTakeAddr = (data: string): Promise<res> =>
  post(
    '/customer/customer/shop/deleteShippingAddress?shopShippingAddressId=' +
    data
  )
// 默认地址
interface ID {
  shopClearanceAddressId?: string
  shopShippingAddressId?: string
}
export const setTakeAddr = (data: ID): Promise<res> =>
  post('/customer/customer/shop/setDefaultShippingAddress', data)

export const setClearAddr = (data: ID): Promise<res> =>
  post('/customer/customer/shop/setDefaultClearanceAddress', data)

// 清关地址
interface CLD {
  address: string
  addressEn: string
  area: string
  areaEn: string
  city: string
  cityEn: string
  companyCode: string
  companyName: string
  companyNameEn: string
  countryCode: string
  phone: string
  postalCode: string
  receiveName: string
  receiveNameEn: string
  shopClearanceAddressId?: string
  defaultAddress: number
}
export const getClearAddr = (): Promise<res> =>
  get('/customer/customer/shop/getClearanceAddressList')

export const updateClearAddr = (data: CLD): Promise<res> =>
  post('/customer/customer/shop/updateClearanceAddress', data)

export const addClearAddr = (data: CLD): Promise<res> =>
  post('/customer/customer/shop/addClearanceAddress', data)

export const delClearAddr = (data: string): Promise<res> =>
  post(
    '/customer/customer/shop/deleteDefaultClearanceAddress?shopClearanceAddressId=' +
    data
  )

// 物流算费
interface LFD {
  intShipConfigId: string
  weight: number
}
export const getLogisticsFee = (data: LFD): Promise<res> =>
  post('/settlement/intShipConfig/getEstimateIntShip', data)

// 获取水洗标配置信息todo
export const getWashingMark = (): Promise<res> =>
  get('/customer/additional/getWashedlabel')

// 更新水洗标配置信息todo

interface WLA {
  'companyAddress': string,
  'companyLogo': string,
  'companyName': string,
  'customerShopId': number,
  'model': number,
  'shopAdditionId': number,
  'shopAddressWashedlabelId': number
}
interface UWM {
  customerShopId: number,
  shopAdditionId: string,
  washedLabelAdditionReqDTO: WLA[]
}
export const updateWashingMark = (data: UWM): Promise<res> =>
  post('/customer/additional/updateWashedlabel', data)
